import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analyticsService';

/**
 * Component to track page views in a Single Page Application
 * This silently tracks route changes and reports them to Google Analytics
 */
const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view when location changes
    analyticsService.trackPageView(location.pathname, document.title);
  }, [location]);
  
  return null; // This component doesn't render anything
};

export default RouteTracker;
